import React, { useEffect, useState } from "react";
import { Form, message, Skeleton } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch} from "@comps/components"
import { makeRequest } from "@utils/helpers";
import { createDataReq } from "../requests";
import { Commons, Const } from "../../constants";
import { getAllServers } from "../../servers/requests";

const langKey = Const["tenants"].lngKey
const formName = "tenants";

const CreateTenant = (props) => {
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [servers, setServers] = useState([]);
  // ------------------------------------
  
  useEffect(() => {
    makeRequest(setLoader, getAllServers,null, onServersSuccess, onServersError)
  },[])
  
  useEffect(() => {
    setRelated()
    // eslint-disable-next-line
  }, []);


  const onServersSuccess = (res) => {
    setServers(res.map(val => (
      { label: val.name, value: val.id }
    )))
}
  
const onServersError = (err) => {
  console.error(err);
  
}

const setRelated=()=> {
  if(!props.related){
    return
  }
}
  const onSubmit = (data) => {
    makeRequest(setLoader, createDataReq, data, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    message.success("Saved successfully");
    props.onCompleted(data)
  }

  const onError = (err, res) => {
  
  }
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ loader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 800 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } name={ formName } onFinish={ onSubmit } scrollToFirstError>
          
          <Form.Item name="subDomain" rules={ rules.subDomain } label={ trans(`${langKey}.subDomain`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.subDomain`) } />
          </Form.Item>
          
          <Form.Item name="domain" rules={ rules.domain } label={ trans(`${langKey}.domain`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.domain`) } />
          </Form.Item>

          <Form.Item name="noOfProcess" rules={ rules.noOfProcess } label={ trans(`${langKey}.noOfProcess`) }
            className="da-mb-16"
          >
            <InputText placeholder={ trans(`${langKey}.noOfProcess`) } />
          </Form.Item>
          
          <Form.Item name="active" rules={ rules.active } label={ trans(`${langKey}.active`) }
            className="da-mb-16"
          >
            <SelectWithSearch options={[
              {label:"Yes",value:1},{label:"No",value:0}
            ]} placeholder={ trans(`${langKey}.active`) } />
          </Form.Item>

          <Form.Item name="serverId" rules={ rules.server } label={ trans(`${langKey}.serverId`) }
            className="da-mb-16"
          >
            <SelectWithSearch options={servers} placeholder={ trans(`${langKey}.serverId`) } />
          </Form.Item>

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default CreateTenant

const rules = {
  subDomain: [
    { required: true, message: trans(`${langKey}.subDomain`) },
  ],
  domain: [
    { required: true, message: trans(`${langKey}.domain`) },
  ],
 
  active: [
    { required: true, message: trans(`${langKey}.active`) },
  ],

  server: [
    { required: true, message: trans(`${langKey}.server`) },
  ],
 
  noOfProcess: [
    { required: true, message: trans(`${langKey}.noOfProcess`) },
  ],
};

const formLayout = {
  layout: "horizontal",
  labelCol: { span: 6 },
  // wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}